import React, { useEffect, useState } from 'react'
import Container from '../../../components/Container';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import DataFetching from "../../../helper/DataFetching";
import renderDataTable from "../../../helper/renderDataTable";
import Loading from "../../../components/Loading";
import { AddButton, ButtonDelete, ButtonEdit, formatMoment } from '../../../helper/CommonFunction';
import EditCategories from './EditCategories';
import Breadcrumb from '../../../components/Breadcrumb';
import AddCategories from './AddCategories';
import { toast } from 'react-toastify';
import { ApiHandler } from '../../../helper/ApiHandler';
import { ModalSmall } from '../../../components/ModalComponets';

const Categories = () => {
    const location = useLocation();
    const token = useSelector((state) => state.user.userToken)
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [filteredData, setFilteredData] = useState([]);
    const [pending, setPending] = useState(true);
    const [resetSearch, setResetSearch] = useState(true);
    const [editId, setEditId] = useState(null);
    const [editModal, setEditModal] = useState(false);
    const [addId, setAddId] = useState(null);
    const [addModal, setAddModal] = useState(false);
    const [deleteId, setdeleteId] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);

    const fetchData = async () => {
        setPending(true);
        await DataFetching(setPending, '/get_category.php', 'POST', token, dispatch, navigate, setFilteredData, undefined, setResetSearch, resetSearch);
    };

    // Render the DataTable component
    useEffect(() => {
        if (!resetSearch) {
            return;
        }
        fetchData();
    }, [location, resetSearch]);


    const openEditModal = row => {
        setEditId(row);
        setEditModal(true);
    };

    const openAddModal = row => {
        setAddId(row);
        setAddModal(true);
    };

    const DeleteUserModal = (row) => {
        setdeleteId(row);
        setDeleteModal(true);
    };

    const column = [
        {
            name: 'Categories ID',
            selector: row => row.id,
            sortable: true,
            width: '20%'
        },
        {
            name: 'Categories Name',
            selector: row => row.category_name,
        },
        {
            name: "Categories Image",
            selector: (row) => (
                <Link to={row.category_image} target='_blank'>
                    <img height={150} width={200} src={row.category_image} alt="image_tag" style={{ objectFit: 'contain' }} />
                </Link>
            ),
            sortable: true,
        },
        {
            name: 'Total Bikes Count',
            selector: row => row.related_bikes,
            width: '20%'
        },
        {
            name: "Actions",
            cell: (row) => (
                <div>
                    <ButtonEdit onclick={() => openEditModal(row)} />
                    <ButtonDelete onclick={() => DeleteUserModal(row)} />
                </div>
            ),
            width: '12%'
        },
    ]

    const DeleteUser = async () => {
        const body = {
            category_id: deleteId.id,
        }

        try {
            const result = await ApiHandler('/delete_category.php', 'POST', body, token, dispatch, navigate)
            if (result?.data.status === "1") {
                toast.success(result?.data.msg)
                setDeleteModal(false)
                setdeleteId(null);
                setResetSearch((prevReset) => !prevReset);
            } else {
                toast.error(result?.data.msg)
            }
        } catch (error) {
            setDeleteModal(false)
        }
    };

    return (
        <>
            <Breadcrumb pageName="Bikes Categories" />
            <Container>
                <>
                    <AddButton text="Add Categories" onClick={openAddModal} />
                    <div className="border-2 border-solid border-[#ddddddbe] w-full">
                        <div className='p-3 w-full'>
                            <div className='py-3'>
                                {renderDataTable(
                                    filteredData,
                                    column,
                                    pending
                                )}
                            </div>
                        </div>
                    </div>
                </>
            </Container>

            {editModal && editId && (
                <EditCategories
                    isOpen={editModal}
                    onClose={() => setEditModal(false)}
                    showData={editId}
                    setResetSearch={setResetSearch}
                    title="Edit Categories"
                />
            )}

            {addModal && addId && (
                <AddCategories
                    isOpen={addModal}
                    onClose={() => setAddModal(false)}
                    setResetSearch={setResetSearch}
                    title="Add Categories"
                />
            )}

            {
                deleteId && deleteModal && (
                    <ModalSmall
                        isOpen={deleteModal}
                        onClose={() => setDeleteModal(false)}
                        onConfirm={DeleteUser}
                    >
                        <div>
                            <h2 className="text-xl font-bold text-gray-800 mb-1">Confirm!</h2>
                            <p className="text-sm text-gray-600 mb-4">
                                Are you sure you want to Delete this Categories?
                            </p>
                        </div>
                    </ModalSmall>
                )
            }
        </>
    )
}

export default Categories;